module.exports = __webpack_public_path__ + "assets/SquareAboutCircleDetailed.d96eb637a4b55f4ce7b055f11548dece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareAboutCircleDetailed.png
// module id = 563
// module chunks = 0